import { toast } from "react-toastify";

import obtenerDirecciones from "../direccion/obtener";
import obtenerConcesiones from "../concesiones/obtener";
import obtenerHistorialPorConcesion from "../historial/obtenerPorConcesion";
import obtenerHistorialSinConcesion from "../historial/obtenerSinConcesion";
import obtenerExpedientePorAutorizacion from "../../xml/obtenerExpedientePorAutorizacion";

import agruparArray from "../../historial/agruparArray";
import mensajePreventivo from "../../mensajes/mensajePreventivo";
import expediente from "../../xml/obtenerExpedientePorAutorizacion";

export default async function obtener(contribuyente, setData, setContribuyentes, setModalIsOpen) {
    const endpoint = `/api/contribuyente/obtener?nombre=${contribuyente?.nombre ?? ""}&paterno=${contribuyente?.apellidoPaterno ?? ""}&materno=${contribuyente?.apellidoMaterno ?? ""}&rfc=${contribuyente?.rfc ?? ""}`;
    try {
        const { dataMultiple, data } = await (await fetch(endpoint)).json();
        if (dataMultiple.length > 1) {
            setContribuyentes([...dataMultiple].slice(0, 10));
            setModalIsOpen(true);
        }
        else {
            try {
                const id = toast.loading("Cargando...");
                let dataHistorial;
                const concesiones = await obtenerConcesiones(data.idContribuyente);
                const direcciones = await obtenerDirecciones(data.idContribuyente);
                if (concesiones[0] !== undefined) dataHistorial = await obtenerHistorialPorConcesion(await concesiones[0].idConcesion);
                else dataHistorial = await obtenerHistorialSinConcesion(await data.idContribuyente);

                const idAutorizacion = await concesiones[0]?.idConcesion;

                if (idAutorizacion) {
                    const dataWS = await expediente(idAutorizacion);
                    concesiones[0].numeroExpediente = await dataWS?.NoExpedienteActual ?? "";
                }

                const dataObject = {
                    contribuyente: data, concesiones: [...concesiones], direcciones: [...direcciones],
                    concesionActual: { ...concesiones[0] }, historial: [...dataHistorial],
                    historialArray: [...agruparArray(dataHistorial, 10)],
                }

                setData(dataObject);
                toast.update(id, { render: "Hecho!", type: "success", isLoading: false, autoClose: 500, draggable: true });
            }
            catch (error) {
                console.log(error);
            }
        }
    }
    catch (_) {
        mensajePreventivo("No se encontró algún resultado", 2000);
    }
}